export default "__VITE_ASSET__CEzh8qD2__"